var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _circle, _path47;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargeTimelineDays(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 172,
    viewBox: "0 0 200 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.871 53.7657C179.655 68.8638 185.443 85.1518 179.766 102.802C173.216 123.162 160.833 144.408 139.205 155.317C117.099 166.466 91.9137 164.194 70.5197 157.902C50.1815 151.921 31.3884 140.592 26.3664 122.13C21.7507 105.162 38.2366 87.8704 46.643 70.1256C55.1969 52.0696 55.9166 29.6617 75.1902 19.0701C94.9778 8.19613 118.327 13.5431 137.25 20.3339C154.136 26.3936 164.396 39.2671 171.871 53.7657Z",
    fill: "#ECF4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.59 45.5907L137.108 45.1934C136.664 45.0746 136.226 45.2715 136.129 45.6333L133.459 55.5965C133.363 55.9582 133.643 56.3478 134.087 56.4667L135.57 56.864C136.013 56.9828 136.451 56.7858 136.548 56.4241L139.218 46.4609C139.315 46.0991 139.034 45.7095 138.59 45.5907Z",
    fill: "#19C0E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.275 46.2714L138.648 46.1036L137.952 48.7011L138.579 48.8689L139.275 46.2714Z",
    fill: "#42D2EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.59 51.2183L158.108 50.821C157.664 50.7022 157.226 50.8991 157.129 51.2609L154.46 61.224C154.363 61.5858 154.643 61.9754 155.087 62.0942L156.57 62.4915C157.013 62.6103 157.451 62.4134 157.548 62.0516L160.218 52.0885C160.315 51.7267 160.034 51.3371 159.59 51.2183Z",
    fill: "#19C0E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.668 39.9839L116.186 39.5866C115.742 39.4678 115.304 39.6647 115.207 40.0265L112.538 49.9897C112.441 50.3514 112.722 50.741 113.165 50.8599L114.648 51.2572C115.091 51.376 115.529 51.179 115.626 50.8172L118.296 40.8541C118.393 40.4923 118.112 40.1027 117.668 39.9839Z",
    fill: "#19C0E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6607 34.3563L95.1779 33.959C94.7345 33.8402 94.2964 34.0372 94.1995 34.3989L91.5299 44.3621C91.4329 44.7239 91.7138 45.1135 92.1572 45.2323L93.64 45.6296C94.0834 45.7484 94.5215 45.5515 94.6184 45.1897L97.288 35.2265C97.385 34.8648 97.1041 34.4752 96.6607 34.3563Z",
    fill: "#19C0E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7388 28.7495L74.256 28.3522C73.8126 28.2334 73.3745 28.4304 73.2776 28.7921L70.608 38.7553C70.511 39.1171 70.7919 39.5067 71.2354 39.6255L72.7181 40.0228C73.1616 40.1416 73.5996 39.9446 73.6965 39.5829L76.3662 29.6197C76.4631 29.2579 76.1822 28.8683 75.7388 28.7495Z",
    fill: "#19C0E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7388 23.122L53.256 22.7247C52.8126 22.6058 52.3745 22.8028 52.2776 23.1646L49.608 33.1277C49.511 33.4895 49.7919 33.8791 50.2354 33.9979L51.7181 34.3952C52.1616 34.514 52.5996 34.3171 52.6965 33.9553L55.3662 23.9921C55.4631 23.6304 55.1822 23.2408 54.7388 23.122Z",
    fill: "#19C0E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M180.52 56.8251L179.037 56.4278C178.594 56.309 178.156 56.5059 178.059 56.8677L175.389 66.8309C175.292 67.1926 175.573 67.5822 176.017 67.7011L177.499 68.0984C177.943 68.2172 178.381 68.0202 178.478 67.6584L181.147 57.6953C181.244 57.3335 180.963 56.9439 180.52 56.8251Z",
    fill: "#19C0E7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M160.282 51.899L159.656 51.7312L158.96 54.3287L159.586 54.4965L160.282 51.899Z",
    fill: "#42D2EA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.353 40.6646L117.727 40.4968L117.031 43.0943L117.657 43.2621L118.353 40.6646Z",
    fill: "#42D2EA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3528 35.0371L96.7266 34.8693L96.0306 37.4667L96.6568 37.6345L97.3528 35.0371Z",
    fill: "#42D2EA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4231 29.4302L75.7969 29.2625L75.1009 31.8599L75.7271 32.0277L76.4231 29.4302Z",
    fill: "#42D2EA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4231 23.8027L54.7969 23.6349L54.1009 26.2324L54.7271 26.4002L55.4231 23.8027Z",
    fill: "#42D2EA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M181.196 57.5035L180.578 57.338L179.606 60.9671L180.223 61.1326L181.196 57.5035Z",
    fill: "#42D2EA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40.5781,
    y: 22.6395,
    width: 151.083,
    height: 100.802,
    rx: 8,
    transform: "rotate(15 40.5781 22.6395)",
    fill: "#155576"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8338 116.53C14.6432 117.241 14.743 117.999 15.1111 118.636C15.4793 119.274 16.0857 119.739 16.7969 119.93L150.509 155.758C153.709 156.616 156.999 154.716 157.857 151.515L180.667 66.3866C181.525 63.1858 179.625 59.8957 176.425 59.0381L45.8268 24.0445C42.626 23.1868 39.336 25.0863 38.4783 28.2871L14.8338 116.53Z",
    fill: "#1C6B93"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M170.382 76.9241L42.4224 42.6375C41.3132 42.3403 40.1731 42.9985 39.8759 44.1077L21.5376 112.547C21.2404 113.656 21.8987 114.796 23.0078 115.094L150.967 149.38C152.076 149.677 153.216 149.019 153.513 147.91L171.852 79.4705C172.149 78.3614 171.491 77.2213 170.382 76.9241Z",
    fill: "#FFFAFD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5673 34.1657L172.112 68.8772C126.496 53.6038 42.5673 34.1657 42.5673 34.1657Z",
    fill: "#155576"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0781 32.214C48.519 32.6001 50.0001 31.745 50.3862 30.304C50.7723 28.8631 49.9172 27.3819 48.4762 26.9958C47.0353 26.6097 45.5542 27.4649 45.1681 28.9058C44.782 30.3468 45.6371 31.8279 47.0781 32.214Z",
    fill: "#155576"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0941 37.9005C70.5731 37.7058 71.6142 36.349 71.4195 34.87C71.2248 33.3909 69.8679 32.3498 68.3889 32.5445C66.9099 32.7392 65.8688 34.0961 66.0635 35.5751C66.2582 37.0541 67.615 38.0952 69.0941 37.9005Z",
    fill: "#155576"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.055 43.5177C91.534 43.323 92.5751 41.9662 92.3804 40.4872C92.1857 39.0081 90.8289 37.967 89.3499 38.1617C87.8709 38.3564 86.8297 39.7133 87.0244 41.1923C87.2192 42.6713 88.576 43.7124 90.055 43.5177Z",
    fill: "#155576"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.016 49.1343C112.495 48.9396 113.536 47.5827 113.341 46.1037C113.147 44.6247 111.79 43.5836 110.311 43.7783C108.832 43.973 107.791 45.3298 107.985 46.8089C108.18 48.2879 109.537 49.329 111.016 49.1343Z",
    fill: "#155576"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M132.978 54.413C134.27 53.6671 134.712 52.0151 133.966 50.7232C133.221 49.4313 131.569 48.9886 130.277 49.7345C128.985 50.4804 128.542 52.1324 129.288 53.4243C130.034 54.7162 131.686 55.1589 132.978 54.413Z",
    fill: "#155576"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M134.433 44.7256L132.951 44.3285C132.846 44.3003 132.737 44.2876 132.632 44.2914C132.526 44.2951 132.426 44.3151 132.337 44.3503C132.247 44.3854 132.171 44.435 132.111 44.4963C132.052 44.5575 132.01 44.6291 131.989 44.7071L130.385 50.694C130.304 50.9966 130.389 51.3303 130.621 51.6219C130.854 51.9134 131.214 52.1389 131.624 52.2486C132.033 52.3583 132.458 52.3434 132.805 52.2071C133.152 52.0707 133.393 51.8241 133.474 51.5216L135.078 45.5347C135.12 45.3772 135.076 45.2035 134.955 45.0518C134.834 44.9001 134.646 44.7827 134.433 44.7256Z",
    fill: "#42D2EA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M134.905 45.7442C135.387 45.254 135.189 44.4908 134.462 44.0395C133.735 43.5881 132.755 43.6195 132.272 44.1096C131.79 44.5998 131.988 45.363 132.715 45.8143C133.442 46.2657 134.422 46.2343 134.905 45.7442Z",
    fill: "#42D2EA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M136.166 43.1193C132.61 42.1664 132.072 44.4223 132.072 44.4223L139.253 46.3464C139.253 46.3464 139.95 44.1323 136.166 43.1193Z",
    fill: "#42D2EA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M153.947 60.0303C155.238 59.2844 155.681 57.6324 154.935 56.3405C154.189 55.0486 152.537 54.606 151.245 55.3518C149.954 56.0977 149.511 57.7497 150.257 59.0416C151.003 60.3335 152.655 60.7762 153.947 60.0303Z",
    fill: "#155576"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M174.908 65.6475C176.199 64.9016 176.642 63.2496 175.896 61.9577C175.15 60.6658 173.498 60.2231 172.206 60.969C170.914 61.7149 170.472 63.3669 171.218 64.6588C171.964 65.9507 173.616 66.3934 174.908 65.6475Z",
    fill: "#155576"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M155.379 50.3365L153.897 49.9394C153.791 49.9111 153.682 49.8985 153.577 49.9022C153.472 49.9059 153.371 49.9259 153.282 49.9611C153.193 49.9963 153.116 50.0459 153.056 50.1071C152.997 50.1683 152.955 50.24 152.935 50.3179L151.33 56.3048C151.249 56.6074 151.334 56.9412 151.567 57.2327C151.799 57.5243 152.159 57.7497 152.569 57.8594C152.979 57.9692 153.404 57.9542 153.751 57.8179C154.097 57.6816 154.338 57.435 154.419 57.1324L156.023 51.1455C156.065 50.9881 156.021 50.8144 155.9 50.6626C155.779 50.5109 155.592 50.3936 155.379 50.3365Z",
    fill: "#42D2EA"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M176.379 55.964L174.897 55.5669C174.791 55.5387 174.683 55.526 174.577 55.5298C174.472 55.5335 174.371 55.5535 174.282 55.5887C174.193 55.6238 174.116 55.6734 174.056 55.7347C173.997 55.7959 173.955 55.8675 173.935 55.9455L172.33 61.9324C172.249 62.235 172.334 62.5687 172.567 62.8603C172.799 63.1518 173.16 63.3773 173.569 63.487C173.979 63.5967 174.404 63.5818 174.751 63.4455C175.098 63.3091 175.338 63.0625 175.419 62.76L177.023 56.7731C177.065 56.6156 177.021 56.4419 176.9 56.2902C176.779 56.1385 176.592 56.0212 176.379 55.964Z",
    fill: "#42D2EA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M113.527 39.1229L112.045 38.7258C111.94 38.6975 111.831 38.6849 111.725 38.6886C111.62 38.6923 111.52 38.7123 111.43 38.7475C111.341 38.7826 111.264 38.8322 111.205 38.8935C111.145 38.9547 111.104 39.0263 111.083 39.1043L109.479 45.0912C109.398 45.3938 109.483 45.7275 109.715 46.0191C109.947 46.3106 110.308 46.5361 110.717 46.6458C111.127 46.7556 111.552 46.7406 111.899 46.6043C112.246 46.4679 112.486 46.2214 112.567 45.9188L114.172 39.9319C114.214 39.7744 114.17 39.6007 114.049 39.449C113.928 39.2973 113.74 39.18 113.527 39.1229Z",
    fill: "#42D2EA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5271 33.4953L91.0451 33.0982C90.9396 33.0699 90.831 33.0573 90.7255 33.061C90.6201 33.0647 90.5198 33.0848 90.4305 33.1199C90.3411 33.1551 90.2645 33.2047 90.2049 33.2659C90.1453 33.3271 90.1039 33.3988 90.0831 33.4767L88.4789 39.4637C88.3978 39.7662 88.4828 40.1 88.7151 40.3915C88.9474 40.6831 89.308 40.9085 89.7175 41.0183C90.1271 41.128 90.5521 41.1131 90.899 40.9767C91.246 40.8404 91.4864 40.5938 91.5675 40.2912L93.1717 34.3043C93.2139 34.1469 93.1696 33.9732 93.0488 33.8214C92.9279 33.6697 92.7402 33.5524 92.5271 33.4953Z",
    fill: "#42D2EA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5974 27.8885L70.1154 27.4914C70.0099 27.4631 69.9013 27.4505 69.7958 27.4542C69.6904 27.4579 69.5901 27.4779 69.5008 27.5131C69.4114 27.5483 69.3348 27.5979 69.2752 27.6591C69.2156 27.7203 69.1742 27.792 69.1534 27.8699L67.5492 33.8569C67.4682 34.1594 67.5531 34.4932 67.7854 34.7847C68.0177 35.0763 68.3783 35.3017 68.7878 35.4114C69.1974 35.5212 69.6224 35.5062 69.9693 35.3699C70.3163 35.2336 70.5567 34.987 70.6378 34.6844L72.242 28.6975C72.2842 28.5401 72.24 28.3664 72.1191 28.2146C71.9982 28.0629 71.8105 27.9456 71.5974 27.8885Z",
    fill: "#42D2EA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5974 22.2609L49.1154 21.8638C49.0099 21.8355 48.9013 21.8229 48.7958 21.8266C48.6904 21.8304 48.5901 21.8504 48.5008 21.8855C48.4114 21.9207 48.3348 21.9703 48.2752 22.0315C48.2156 22.0928 48.1742 22.1644 48.1534 22.2424L46.5492 28.2293C46.4682 28.5318 46.5531 28.8656 46.7854 29.1571C47.0177 29.4487 47.3783 29.6741 47.7878 29.7839C48.1974 29.8936 48.6224 29.8787 48.9693 29.7423C49.3163 29.606 49.5567 29.3594 49.6378 29.0569L51.242 23.07C51.2842 22.9125 51.24 22.7388 51.1191 22.5871C50.9982 22.4354 50.8105 22.318 50.5974 22.2609Z",
    fill: "#42D2EA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M155.85 51.355C156.333 50.8649 156.134 50.1017 155.407 49.6503C154.681 49.1989 153.7 49.2304 153.217 49.7205C152.735 50.2106 152.933 50.9738 153.66 51.4252C154.387 51.8765 155.368 51.8451 155.85 51.355Z",
    fill: "#42D2EA"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M176.85 56.9826C177.333 56.4924 177.134 55.7292 176.407 55.2779C175.681 54.8265 174.7 54.8579 174.217 55.348C173.735 55.8382 173.933 56.6014 174.66 57.0527C175.387 57.5041 176.368 57.4727 176.85 56.9826Z",
    fill: "#42D2EA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M113.998 40.1414C114.481 39.6513 114.283 38.888 113.556 38.4367C112.829 37.9853 111.848 38.0167 111.366 38.5068C110.883 38.997 111.081 39.7602 111.808 40.2116C112.535 40.6629 113.516 40.6315 113.998 40.1414Z",
    fill: "#42D2EA"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9985 34.5138C93.481 34.0237 93.2829 33.2605 92.5559 32.8091C91.829 32.3577 90.8485 32.3892 90.3659 32.8793C89.8834 33.3694 90.0815 34.1326 90.8085 34.584C91.5355 35.0354 92.516 35.0039 92.9985 34.5138Z",
    fill: "#42D2EA"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0688 28.907C72.5514 28.4169 72.3532 27.6537 71.6262 27.2023C70.8993 26.7509 69.9188 26.7824 69.4362 27.2725C68.9537 27.7626 69.1518 28.5258 69.8788 28.9772C70.6058 29.4285 71.5863 29.3971 72.0688 28.907Z",
    fill: "#42D2EA"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0688 23.2794C51.5514 22.7893 51.3532 22.0261 50.6262 21.5747C49.8993 21.1234 48.9188 21.1548 48.4362 21.6449C47.9537 22.135 48.1518 22.8983 48.8788 23.3496C49.6058 23.801 50.5863 23.7696 51.0688 23.2794Z",
    fill: "#42D2EA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M157.103 48.7301C153.547 47.7773 153.009 50.0332 153.009 50.0332L160.19 51.9572C160.19 51.9572 160.887 49.7432 157.103 48.7301Z",
    fill: "#42D2EA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M178.103 54.3577C174.547 53.4048 174.009 55.6607 174.009 55.6607L181.19 57.5848C181.19 57.5848 181.887 55.3707 178.103 54.3577Z",
    fill: "#42D2EA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M115.252 37.5164C111.696 36.5635 111.158 38.8194 111.158 38.8194L118.338 40.7435C118.338 40.7435 119.036 38.5294 115.252 37.5164Z",
    fill: "#42D2EA"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2517 31.889C90.6956 30.9361 90.1579 33.192 90.1579 33.192L97.3385 35.116C97.3385 35.116 98.0355 32.902 94.2517 31.889Z",
    fill: "#42D2EA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3221 26.282C69.7659 25.3292 69.2282 27.5851 69.2282 27.5851L76.4088 29.5091C76.4088 29.5091 77.1058 27.295 73.3221 26.282Z",
    fill: "#42D2EA"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3221 20.6546C48.7659 19.7017 48.2282 21.9576 48.2282 21.9576L55.4088 23.8816C55.4088 23.8816 56.1058 21.6676 52.3221 20.6546Z",
    fill: "#42D2EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9688,
    y: 49.4694,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 47.9688 49.4694)",
    fill: "#D1EDF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.4141,
    y: 81.3926,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 39.4141 81.3926)",
    fill: "#D1EDF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6953,
    y: 65.431,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 43.6953 65.431)",
    fill: "#D1EDF2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1406,
    y: 97.3542,
    width: 13.2197,
    height: 13.3771,
    rx: 3,
    transform: "rotate(15 35.1406 97.3542)",
    fill: "#D1EDF2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 98.7422,
    y: 63.074,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 98.7422 63.074)",
    fill: "#D1EDF2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 94.4688,
    y: 79.0356,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 94.4688 79.0356)",
    fill: "#D1EDF2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 102.462,
    y: 116,
    width: 13.2197,
    height: 13.3771,
    rx: 3,
    transform: "rotate(15 102.462 116)",
    fill: "#D1EDF2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 64.8438,
    y: 53.9907,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 64.8438 53.9907)",
    fill: "#D1EDF2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5703,
    y: 69.9523,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 60.5703 69.9523)",
    fill: "#D1EDF2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 56.4214,
    y: 86,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 56.4214 86)",
    fill: "#1C6B93"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 115.617,
    y: 67.5953,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 115.617 67.5953)",
    fill: "#D1EDF2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 111.344,
    y: 83.5569,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 111.344 83.5569)",
    fill: "#D1EDF2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 149.367,
    y: 76.6379,
    width: 13.3771,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 149.367 76.6379)",
    fill: "#D1EDF2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 145.086,
    y: 92.5995,
    width: 13.3771,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 145.086 92.5995)",
    fill: "#D1EDF2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 136.531,
    y: 124.523,
    width: 13.3771,
    height: 13.3771,
    rx: 3,
    transform: "rotate(15 136.531 124.523)",
    fill: "#D1EDF2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 81.7188,
    y: 58.512,
    width: 13.3771,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 81.7188 58.512)",
    fill: "#D1EDF2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 73.164,
    y: 90.4352,
    width: 13.3771,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 73.164 90.4352)",
    fill: "#D1EDF2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 68.4214,
    y: 107,
    width: 13.3771,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 68.4214 107)",
    fill: "#D1EDF2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 51.4214,
    y: 103,
    width: 13.3771,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 51.4214 103)",
    fill: "#D1EDF2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 90.4214,
    y: 95,
    width: 13.3771,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 90.4214 95)",
    fill: "#D1EDF2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 85.4214,
    y: 111,
    width: 13.3771,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 85.4214 111)",
    fill: "#D1EDF2"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 107.421,
    y: 100,
    width: 13.3771,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 107.421 100)",
    fill: "#D1EDF2"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 77.4375,
    y: 74.4735,
    width: 13.3771,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 77.4375 74.4735)",
    fill: "#D1EDF2"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 132.492,
    y: 72.1166,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 132.492 72.1166)",
    fill: "#D1EDF2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 128.211,
    y: 88.0782,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 128.211 88.0782)",
    fill: "#D1EDF2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 124.266,
    y: 104.328,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 124.266 104.328)",
    fill: "#D1EDF2"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 141.422,
    y: 109,
    width: 13.2197,
    height: 13.2197,
    rx: 3,
    transform: "rotate(15 141.422 109)",
    fill: "#D1EDF2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 119.664,
    y: 120.001,
    width: 13.2197,
    height: 13.3771,
    rx: 3,
    transform: "rotate(15 119.664 120.001)",
    fill: "#D1EDF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 157.5,
    cy: 138.5,
    r: 23.5,
    fill: "#6ACE8B",
    stroke: "white",
    strokeWidth: 4
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M164.986 143.03C164.986 144.63 164.426 145.98 163.306 147.08C162.206 148.18 160.716 148.87 158.836 149.15V151.04C158.836 151.5 158.696 151.87 158.416 152.15C158.136 152.45 157.766 152.6 157.306 152.6C156.846 152.6 156.476 152.45 156.196 152.15C155.916 151.87 155.776 151.5 155.776 151.04V149.21C154.636 149.11 153.526 148.87 152.446 148.49C151.366 148.11 150.436 147.61 149.656 146.99C149.396 146.81 149.216 146.61 149.116 146.39C149.016 146.17 148.966 145.9 148.966 145.58C148.966 145.16 149.086 144.79 149.326 144.47C149.586 144.15 149.876 143.99 150.196 143.99C150.396 143.99 150.576 144.03 150.736 144.11C150.916 144.17 151.146 144.28 151.426 144.44C152.346 145.04 153.246 145.48 154.126 145.76C155.026 146.04 155.966 146.18 156.946 146.18C158.286 146.18 159.316 145.92 160.036 145.4C160.776 144.88 161.146 144.13 161.146 143.15C161.146 142.57 160.946 142.1 160.546 141.74C160.146 141.38 159.646 141.1 159.046 140.9C158.446 140.68 157.606 140.43 156.526 140.15C155.026 139.77 153.806 139.39 152.866 139.01C151.926 138.61 151.116 138.01 150.436 137.21C149.756 136.41 149.416 135.33 149.416 133.97C149.416 132.35 149.996 130.97 151.156 129.83C152.316 128.69 153.836 127.98 155.716 127.7V125.81C155.716 125.35 155.856 124.98 156.136 124.7C156.416 124.4 156.786 124.25 157.246 124.25C157.706 124.25 158.076 124.4 158.356 124.7C158.636 124.98 158.776 125.35 158.776 125.81V127.67C160.796 127.93 162.536 128.66 163.996 129.86C164.476 130.22 164.716 130.69 164.716 131.27C164.716 131.69 164.586 132.06 164.326 132.38C164.086 132.7 163.796 132.86 163.456 132.86C163.276 132.86 163.096 132.83 162.916 132.77C162.756 132.71 162.536 132.59 162.256 132.41C161.436 131.83 160.656 131.4 159.916 131.12C159.196 130.82 158.336 130.67 157.336 130.67C156.096 130.67 155.106 130.95 154.366 131.51C153.626 132.05 153.256 132.8 153.256 133.76C153.256 134.42 153.466 134.96 153.886 135.38C154.306 135.78 154.836 136.09 155.476 136.31C156.116 136.53 156.986 136.78 158.086 137.06C159.546 137.42 160.736 137.79 161.656 138.17C162.576 138.55 163.356 139.13 163.996 139.91C164.656 140.67 164.986 141.71 164.986 143.03Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeTimelineDays);
export default __webpack_public_path__ + "static/media/ChargeTimelineDays.e90fa1bc08e4e881ca9f80f2b46a9fd6.svg";
export { ForwardRef as ReactComponent };